module.exports = __webpack_public_path__ + "img/PIC_stian2.0654fd50.jpg";